import React from 'react';
import styled from 'styled-components';
import { TextBlockWrapper } from '@hotelplan/components.common.text-block';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';

interface IGeoTextBlockProps {
  title: string;
  text: string;
}

const TextBlockTitle = styled.h1(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: 'column',
    '.text-block-title': {
      mb: [2, 4],
      fontSize: ['42px', '65px'],
    },
  })
);

const Dash = styled.span(
  sx2CssThemeFn({
    clip: `rect(0,0,0,0)`,
    border: 0,
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: '1px',
  })
);

const TextBlockTagline = styled.span(({ theme: { media, fontSizes } }) => ({
  fontSize: fontSizes[2],
  [media.tablet]: {
    fontSize: fontSizes[4],
  },
  'ul,ol': {
    fontSize: fontSizes[2],
  },
}));

const GeoTextBlock: React.FC<IGeoTextBlockProps> = ({ title, text }) => {
  return (
    <TextBlockWrapper className="home-static-text">
      <TextBlockTitle>
        <TextBlockTagline
          className="text-block-text"
          dangerouslySetInnerHTML={{ __html: text }}
        />
        <Dash>{' - '}</Dash>
        {title ? (
          <span
            className="text-block-title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        ) : null}
      </TextBlockTitle>
    </TextBlockWrapper>
  );
};

export default GeoTextBlock;
